/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './recommend.defs.js'
export { main as default } from './recommend.defs.js'
